var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AxiosHeaders } from 'axios';
import http from '../util/customAxios';
var Page = /** @class */ (function () {
    function Page() {
        this.content = [];
        this.size = 10;
        this.pageable = {
            offset: 0,
            pageSize: 10,
            pageNumber: 0,
            paged: true,
            unpaged: false,
        };
        this.totalPages = 0;
        this.totalElements = 0;
    }
    return Page;
}());
export { Page };
var MunicipiosOrigemApi = /** @class */ (function () {
    function MunicipiosOrigemApi() {
    }
    var _a;
    _a = MunicipiosOrigemApi;
    MunicipiosOrigemApi.getMunicipiosOrigem = function () { return __awaiter(void 0, void 0, Promise, function () {
        var response;
        return __generator(_a, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, http.get("/municipios-origem")];
                case 1:
                    response = _b.sent();
                    return [2 /*return*/, response.data];
            }
        });
    }); };
    MunicipiosOrigemApi.findById = function (id) { return __awaiter(void 0, void 0, Promise, function () {
        var response;
        var _b, _c;
        return __generator(_a, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, http.get("/municipios-origem/".concat(id))];
                case 1:
                    response = _d.sent();
                    return [2 /*return*/, __assign(__assign({}, response.data), { uf: (_b = response.data.uf) !== null && _b !== void 0 ? _b : 'MT', codigo: (_c = response.data.codigo) !== null && _c !== void 0 ? _c : undefined })];
            }
        });
    }); };
    MunicipiosOrigemApi.selectAllMunicipiosOrigemDe = function (id) { return __awaiter(void 0, void 0, Promise, function () {
        var response;
        return __generator(_a, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, http.get("/municipios-origem/".concat(id, "/originaram/v2"))];
                case 1:
                    response = _b.sent();
                    return [2 /*return*/, response.data];
            }
        });
    }); };
    MunicipiosOrigemApi.selectAllMunicipiosOrigemAtivos = function () { return __awaiter(void 0, void 0, Promise, function () {
        var response;
        return __generator(_a, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, http.get("/municipios-origem/ativos")];
                case 1:
                    response = _b.sent();
                    return [2 /*return*/, response.data];
            }
        });
    }); };
    // Outras funções permanecem inalteradas
    MunicipiosOrigemApi.criar = function (payload) { return __awaiter(void 0, void 0, Promise, function () {
        var response;
        return __generator(_a, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, http.post("/municipios-origem", payload)];
                case 1:
                    response = _b.sent();
                    return [2 /*return*/, response.data];
            }
        });
    }); };
    MunicipiosOrigemApi.atualizar = function (payload) { return __awaiter(void 0, void 0, Promise, function () {
        var response;
        return __generator(_a, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, http.put("/municipios-origem/".concat(payload === null || payload === void 0 ? void 0 : payload.id), payload)];
                case 1:
                    response = _b.sent();
                    return [2 /*return*/, response.data];
            }
        });
    }); };
    MunicipiosOrigemApi.pageable = function (page) { return __awaiter(void 0, void 0, Promise, function () {
        var response;
        return __generator(_a, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, http.get("/municipios-origem/paginado", { params: page })];
                case 1:
                    response = _b.sent();
                    return [2 /*return*/, response.data];
            }
        });
    }); };
    MunicipiosOrigemApi.selectAllMunicipiosAnteriores = function (params) { return __awaiter(void 0, void 0, Promise, function () {
        var response;
        return __generator(_a, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, http.get("/municipios-origem/criados-antes", { params: params })];
                case 1:
                    response = _b.sent();
                    return [2 /*return*/, response.data];
            }
        });
    }); };
    MunicipiosOrigemApi.alterarSituacaoMunicipioOrigem = function (id, params, payload) { return __awaiter(void 0, void 0, Promise, function () {
        var headers, response;
        return __generator(_a, function (_b) {
            switch (_b.label) {
                case 0:
                    headers = new AxiosHeaders();
                    headers.set('enctype', 'multipart/form-data');
                    headers.set('Content-Type', 'multipart/form-data');
                    return [4 /*yield*/, http.put("/municipios-origem/".concat(id, "/status"), payload, { headers: headers, params: params })];
                case 1:
                    response = _b.sent();
                    return [2 /*return*/, response.data];
            }
        });
    }); };
    return MunicipiosOrigemApi;
}());
export { MunicipiosOrigemApi };
